import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Navigation, Router, UrlTree } from '@angular/router';
import { UserStartRouteService } from 'src/app/view/user-context/services/user-start-route.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class CrmModuleGuard implements CanActivate, CanActivateChild {
  private accessCheck?: { navigation: Navigation; userId: string; result: Promise<boolean | UrlTree> };

  constructor(
    private authService: AuthService,
    private userStartRoute: UserStartRouteService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const userId = await this.authService.getCurrentUserUidOnce();
    if (!userId) return this.router.parseUrl('/signIn');
    const navigation = this.router.getCurrentNavigation();
    if (navigation && this.accessCheck?.navigation === navigation && this.accessCheck.userId === userId) {
      return this.accessCheck.result;
    }

    // ? Parent and child guards share one check; the next navigation reads current grants again.
    const result = this.checkAccess(userId);
    this.accessCheck = navigation ? { navigation, userId, result } : undefined;
    return result;
  }

  private async checkAccess(userId: string): Promise<boolean | UrlTree> {
    const access = await this.userStartRoute.getCrmModuleAccess(userId);
    if (access.hasCrmAccess) return true;
    if (access.offersCompanyId) {
      this.userStartRoute.activateOffersContext(userId, access.offersCompanyId);
      return this.router.parseUrl('/offers');
    }
    return this.router.parseUrl('/signIn');
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.canActivate();
  }
}
